module.exports = __webpack_public_path__ + "static/balvanera-logo-circle-7455b00e574e1514f3b4b6964760dac8.svg";